import React, { ComponentProps } from 'react';

import { BaseInputField } from './BaseInputField';

export const TextField = (props: ComponentProps<typeof BaseInputField>) => {
  return <BaseInputField {...props} />;
};
